//#region Function Imports
import React, { useState, useEffect, useRef } from 'react';
import { View, Text, StyleSheet, FlatList, SafeAreaView, TouchableOpacity, Dimensions, Pressable, Platform, useWindowDimensions, ActivityIndicator } from 'react-native';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { useTheme, useIsFocused } from '@react-navigation/native';
import { Card, Provider } from 'react-native-paper';
import CustomButton from '../../../components/CustomButton';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { useLeave } from '../../../hooks/useLeave';
import * as mime from 'react-native-mime-types';
import filter from 'lodash.filter';
import Modal from "react-native-modal";
import { createCommonStyles } from '../../../styles/commonStyles';
import { useTranslation } from 'react-i18next';
import ReactNativeBlobUtil from 'react-native-blob-util';
import { useSafeAreaInsets } from "react-native-safe-area-context";
const androidUtil = ReactNativeBlobUtil.android
const iosUtil = ReactNativeBlobUtil.ios

//#endregion

const MyLeavesScreen = (props) => {

    //#region Const definitions
    const moment = require('moment');
    const { width, height } = useWindowDimensions();
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const styles = makeStyles(colors, props, width);
    const { t, i18n } = useTranslation();
    const { oasisParam } = useAccountContext();
    const { isLoading: useLeaveIsLoading, GetLeaves, GetFiscalYears } = useLeave()
    const deviceWidth = Dimensions.get("window").width;
    const deviceHeight = Dimensions.get("window").height

    const isFocused = useIsFocused();
    const refreshTime = 300000;
    const insets = useSafeAreaInsets();
    //#endregion

    //#region State Definitions
    const [data, setData] = useState([]);
    const [absDetailYear, setAbsDetailYear] = useState('')
    const [mYr, setMyr] = useState([]);
    const [query, setQuery] = useState('');
    const [fullData, setFullData] = useState([]);
    const [approved, setApproved] = useState(true);
    const [rejected, setRejected] = useState(true);
    const [submitted, setSubmitted] = useState(true);
    const [spacerFlag, setSpacerFlag] = useState(false);
    const approvedRef = useRef(true);
    const rejectedRef = useRef(true);
    const submittedRef = useRef(true);
    const [dateOrder, setDateOrder] = useState('desc');
    const dateOrderRef = useRef('desc');
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const [isSorting, setIsSorting] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    //#endregion

    //#region UseEffect Functions
    // * Setting Refs to get values before re-render
    useEffect(() => {
        dateOrderRef.current = dateOrder;
    }, [dateOrder]);

    useEffect(() => {
        approvedRef.current = approved;
    }, [approved]);

    useEffect(() => {
        rejectedRef.current = rejected;
    }, [rejected]);

    useEffect(() => {
        submittedRef.current = submitted;
    }, [submitted]);

    useEffect(() => {
    }, [absDetailYear])

    useEffect(() => {
        // * instead of loading on Useeffect load everytime window is focused 
        // * Call Async Function
        onGetFiscalYear().catch();
        onGetLeaves();
        const comInterval = setInterval(onGetLeaves, refreshTime); //* This will refresh the data at regularIntervals of refreshTime
        return () => clearInterval(comInterval) //* Clear interval on component unmount to avoid memory leak
        // * Get Fiscal years different for every employee. Depending on entries in Absdetails
    }, [isFocused]);
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );

    useEffect(() => {
        props.currDate !== '' && handleSearch(props.currDate)
    }, [props.currDate]);
    //#endregion

    //#region Toggle Functions
    // * Hide Modal and change filtering options depending on user selection
    const toggleModalSortAsc = () => {
        setDateOrder("asc")
    };
    const toggleModalSortDsc = () => {
        setDateOrder("desc")
    };

    // * Filter and Sorting Listeners 
    const toggleModalFilterAll = () => {
        setApproved(true);
        setRejected(true);
        setSubmitted(true);
    };
    const toggleModalFilterSub = () => {
        setApproved(false);
        setRejected(false);
        setSubmitted(true);
    };
    const toggleModalFilterApr = () => {
        setApproved(true);
        setRejected(false);
        setSubmitted(true);
    };
    const toggleModalFilterUnSub = () => {
        setApproved(false);
        setRejected(false);
        setSubmitted(false);
    };
    const toggleModalFilterRej = () => {
        setApproved(false);
        setRejected(true);
        setSubmitted(true);
    };
    //#endregion

    //#region API calls
    const onGetLeaves = () => {
        if (!useLeaveIsLoading)
            GetLeaves(dateOrderRef.current, approvedRef.current, rejectedRef.current, submittedRef.current, absDetailYear, props.isDashboard)
                .then((response) => {
                    if (response !== undefined) {
                        setData(response);
                        setFullData(response);
                    }
                })
                .catch((error) => {
                    console.error;
                });
    }
    const onGetFiscalYear = async () => {
        await GetFiscalYears().then((response) => setMyr(response)).catch(console.error)
    }

    //#endregion

    //#region Listeners
    //* Render flat list data (leavelines)
    // https://stackoverflow.com/questions/44743904/virtualizedlist-you-have-a-large-list-that-is-slow-to-update
    const RenderLeaveLine = ({ item }) => {
        return (
            <View key={item} style={styles.leaveLine}>
                <SafeAreaView style={styles.row}>
                    <CustomLabel
                        value={moment(item.linedate).format("MMM DD YYYY") + ' - ' + item.nameofday}
                        type='LEAVEDETAILSMAJOR' />
                    {item.details !== "" ?
                        <CustomLabel
                            value={item.details}
                            type='LEAVEDETAILSMAJOR' /> : <></>
                    }
                    <CustomLabel
                        value={item.duration + ' ' + t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? oasisParam.leaveUnit === "H" ? "ώρες" : "ημέρες" : oasisParam.leaveUnit === "H" ? "hours" : "days" })}
                        type='LEAVEDETAILSMINOR' />
                </SafeAreaView>
            </View>
        )
    };

    // TODO: check if below works for android and ios and clean up code
    // TODO: for web, currently works for pdf and png (not working for excel and word)
    const openAttachment = async (item) => {
        // var blob = new Blob([new Uint8Array(byteArray)], { type: {item.type} });
        // // create a path you want to write to
        // var path = FileSystem.documentDirectory + '/' + item.name + '.' + item.type;
        // // write the file
        // FileSystem.writeFile(path, item.data, 'base64')
        //     .then((success) => {
        //         console.log('FILE WRITTEN at ' + path);
        //     })
        //     .catch((err) => {
        //         console.log(err.message);
        //     });

        // // const path = FileViewer.open(documents[index].uri, { showOpenWithDialog: true })
        // FileViewer.open(path)
        //     .then(() => {
        //         // console.log("success");
        //     })
        //     .catch((error) => {
        //         console.log(error);
        //         // axiosErrorHandling(error);
        //     });

        // android.actionViewIntent(path, item.type);

        //*
        // const dirPath = ReactNativeBlobUtil.fs.dirs.DocumentDir;
        // const filePath = dirPath + `/${attachmentsRef.current[key].name}`;

        // let reader = new FileReader();
        // reader.readAsText(attachmentsRef.current[key], 'UTF-8');

        // reader.onload = function () {
        //     console.log(reader.result);
        //     // write the file
        //     ReactNativeBlobUtil.fs.writeStream(
        //         filePath,
        //         // encoding, should be one of `base64`, `utf8`, `ascii`
        //         'utf8',
        //         // should data append to existing content ?
        //         true
        //     )
        //         .then(stream => Promise.all([
        //             stream.write(reader.result)
        //             // stream.write('bar'),
        //             // stream.write('foobar')
        //         ]))
        //         // Use array destructuring to get the stream object from the first item of the array we get from Promise.all()
        //         .then(([stream]) => stream.close())
        //         .catch(console.error)
        // };

        // reader.onerror = function () {
        //     console.log(reader.error);
        // };
        //*/

        if (Platform.OS === 'web') {
            // create blob
            const blobData = await fetch(`data:plain/text;base64,${item.data}`).then(res => {
                return res.blob();
            });

            // create download link
            const url = URL.createObjectURL(blobData);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `${item.name}.${item.type}`,
            );

            // insert link on page
            document.body.appendChild(link);

            // start download
            link.click();

            // remove link
            link.parentNode.removeChild(link);
        } else {
            // for ios, use documents directory
            // for android, use downloads directory
            // note: documents directory can be used for both android and ios
            const dirPath =
                Platform.OS === 'ios'
                    ? `${ReactNativeBlobUtil.fs.dirs.DocumentDir}`
                    : `${ReactNativeBlobUtil.fs.dirs.DownloadDir}`;

            const filePath = dirPath + `/${item.name}.${item.type}`;

            // create file
            ReactNativeBlobUtil.fs.writeFile(filePath, item.data, 'base64')
                .then((success) => {
                    // console.log('FILE WRITTEN!');
                })
                .catch((err) => {
                    console.log(err.message);
                });

            // open file
            if (Platform.OS === 'ios') {
                iosUtil.openDocument(filePath);
            } else {
                androidUtil.actionViewIntent(filePath, mime.lookup(item.type));
            };
        };
    };

    //#region Function Listeners 
    //* Show/Hide extra details for leave. Main details are leave type, dates
    const ShowHideMenu = (item) => {
        const [showDetails, setShowDetails] = React.useState(false);
        let period = `${item.startdate} - ${item.enddate}`
        let status = '';
        let textColor = ''
        let specificColor = ''
        if (item.status == 'Approved') {
            status = 'APPROVED'
            specificColor = colors.background_approved
            textColor = colors.text_approved
        }
        else if (item.status == 'Rejected') {
            status = 'REJECTED'
            specificColor = colors.background_rejected
            textColor = colors.text_pending
        }
        else {
            status = 'PENDING'
            specificColor = colors.card_pending
            textColor = colors.text_pending
        }
        const onShowHidePress = (item) => {
            setShowDetails(!showDetails);
        };
        return (
            // * FlatList Main Data
            <View style={styles.showHide}>
                <Pressable onPress={() => onShowHidePress(item)}>
                    {Platform.OS === 'web' && width > 1200 ?
                        <View
                            style={styles.row}>
                            {/* Removed from feedback */}
                            {/* <View
                                style={[
                                    styles.leaveState,
                                    { backgroundColor: item.acodeColour },
                                ]} /> */}
                            <CustomLabel
                                value={item.acodeDesc}
                                type='AVAILABLEUSED' />
                            <View style={styles.marginhor}>
                                <CustomLabel
                                    value={item.startdate}
                                    type='AVAILABLEUSED_SECONDARY' />
                                <CustomLabel
                                    value={t('common:startDate')}
                                    type='AVAILABLEUSED_MUTED' />
                            </View>
                            <View style={styles.marginhor}>
                                <CustomLabel
                                    value={item.enddate}
                                    type='AVAILABLEUSED_SECONDARY' />
                                <CustomLabel
                                    value={t('common:endDate')}
                                    type='AVAILABLEUSED_MUTED' />
                            </View>
                            <CustomLabel
                                value={item.duration + " " + t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? oasisParam.leaveUnit === "H" ? "ώρες" : "ημέρες" : oasisParam.leaveUnit === "H" ? "hours" : "days" })}
                                type='AVAILABLEUSED_SECONDARY' />
                            <CustomLabel
                                value={status}
                                type='STATUS'
                                specificColor={specificColor}
                                textColor={textColor} />

                            {props.isDashboard === false && <View
                                style={{
                                    flex: 1,
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignSelf: "center",
                                    alignItems: "center",

                                }}>
                                {(item.status == 'Not Submitted') &&
                                    <CustomButton
                                        type="EDITBUTTON"
                                        text={t('common:edit')}
                                        isGradient={true}
                                        iconName="checkmark-outline"
                                        onPress={() => {
                                            let leaveToEdit = {
                                                editLeave: true,
                                                acode: item.acode,
                                                startDate: item.startdate,
                                                endDate: item.enddate,
                                                comments: item.comments,
                                                leaveId: item.rowguid,
                                                replacementId: item.replacementid
                                            }
                                            props.selectNewLeaveScreen(leaveToEdit)
                                        }}
                                        show="HIDE"
                                    />
                                }
                            </View>}


                        </View>
                        :
                        <View
                            style={styles.flexStart}>
                            <View
                                style={styles.row}>

                                <View
                                    style={[
                                        styles.leaveState,
                                        { backgroundColor: item.acodeColour },
                                    ]} />
                                <View
                                    style={styles.spaceBetween}>
                                    <CustomLabel
                                        value={period}
                                        type='AVAILABLEUSED' />
                                    <CustomLabel
                                        value={item.acodeDesc}
                                        type='AVAILABLEUSED_SMALL' />

                                </View>
                            </View>
                            <View
                                style={styles.spaceStatus}>
                                <CustomLabel
                                    value={status}
                                    type='STATUS'
                                    specificColor={specificColor} />
                            </View>
                        </View>
                    }
                </Pressable>

                {showDetails == true && props.isDashboard === false &&
                    <SafeAreaView style={styles.showDetails}>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:LT') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.acodeDesc}
                                    type='LEAVEDETAILSMINOR' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:LD') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.startdate + ` - ` + item.enddate}
                                    type='LEAVEDETAILSMINOR' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:Dur') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.duration + " " + t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? oasisParam.leaveUnit === "H" ? "ώρες" : "ημέρες" : oasisParam.leaveUnit === "H" ? "hours" : "days" })}
                                    type='LEAVEDETAILSMINOR' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:Comm') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.comments}
                                    type='LEAVEDETAILSMINOR' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:ls') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.status}
                                    type='LEAVEDETAILSMINOR' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>

                        {/* show leavelines */}
                        {/* flatlist or map? */}
                        {item.leavelines.length > 0 &&
                            <SafeAreaView style={styles.black}>
                                <CustomLabel
                                    value={t('common:LL') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <SafeAreaView>
                                    {item.leavelines.map((item, index) => {
                                        return (
                                            <View style={styles.row}
                                                key={index}>
                                                <CustomLabel
                                                    value={moment(item.linedate).format("MMM DD YYYY") + ' - ' + item.nameofday}
                                                    type='LEAVEDETAILSMAJOR' />
                                                {/* {item.details !== "" ?
                                                    <CustomLabel
                                                        value={item.details}
                                                        type='LEAVEDETAILSMAJOR' /> : <></>
                                                } */}
                                                <CustomLabel
                                                    value={item.duration + ' ' + t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? oasisParam.leaveUnit === "H" ? "ώρες" : "ημέρες" : oasisParam.leaveUnit === "H" ? "hours" : "days" })}
                                                    type='LEAVEDETAILSMINOR' />
                                            </View>
                                        )
                                    })
                                    }
                                </SafeAreaView>
                                <View style={styles.line} />
                            </SafeAreaView>}

                        {/* show approvers */}
                        {item.leaveApprovers.length > 0 &&
                            <SafeAreaView style={styles.approverContainer}>
                                <CustomLabel
                                    value={t('common:lAppr') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <SafeAreaView>
                                    {item.leaveApprovers.map((approver) => {
                                        return (
                                            <View key={approver.id} style={styles.row}>
                                                <CustomLabel
                                                    value={approver.name}
                                                    type='LEAVEDETAILSMAJOR' />
                                                <CustomLabel
                                                    value={approver.status}
                                                    type='LEAVEDETAILSMINOR' />
                                            </View>
                                        )
                                    })}
                                </SafeAreaView>
                                <View style={styles.line} />
                            </SafeAreaView>
                        }

                        {/* show rejection comments */}
                        {item.rejectionComments.length > 0 &&
                            <SafeAreaView style={styles.item}>
                                <View
                                    style={styles.row}>
                                    <CustomLabel
                                        value={t('common:approverComments') + `:`}
                                        type='LEAVEDETAILSMAJOR' />
                                    <CustomLabel
                                        value={item.rejectionComments}
                                        type='LEAVEDETAILSMINOR' />
                                </View>
                                <View style={styles.line} />
                            </SafeAreaView>
                        }

                        {/* show attachments */}
                        {item.leaveAttachments.length > 0 &&
                            <SafeAreaView style={styles.approverContainer}>
                                <CustomLabel
                                    value={t('common:lAttach') + `:`}
                                    type='LEAVEDETAILSMAJOR' />

                                {item.leaveAttachments.map((attachment) => {
                                    return (
                                        <TouchableOpacity key={attachment.name + '.' + attachment.type} onPress={() => openAttachment(attachment)}>
                                            <CustomLabel
                                                value={attachment.name + '.' + attachment.type.toLowerCase()}
                                                type='LEAVEDETAILSMINORLINK' />
                                        </TouchableOpacity>
                                    )
                                })}
                                <View style={styles.line} />
                            </SafeAreaView>}

                        {/* if not submitted then appear buttons to edit and save */}
                        {(Platform.OS !== 'web' || width < 1200) && <View
                            style={{
                                height: 50,
                                flexDirection: 'row',
                                alignSelf: "center",
                            }}>
                            {item.status == 'Not Submitted' && <CustomButton
                                // onPress={() => AcceptLeave(item)}
                                type="APPROVE"
                                isGradient={true}
                                text={t('common:edit')}
                                iconName="checkmark-outline"
                                onPress={() => {
                                    let leaveToEdit = {
                                        editLeave: true,
                                        acode: item.acode,
                                        startDate: item.startdate,
                                        endDate: item.enddate,
                                        comments: item.comments,
                                        leaveId: item.rowguid,
                                        replacementId: item.replacementid
                                    }
                                    props.selectNewLeaveScreen(leaveToEdit)
                                }}
                                show="HIDE"
                            />}
                        </View>}

                    </SafeAreaView>
                }
            </View >
        );
    };

    const clickedItem = (data) => {
        // console.log("TODO Listener for clicking the whole card, Maybe for adding extra INFO ... ALSO ADD ATTACHMENTS")
    };
    const onFilterPressed = () => {
        setIsSorting(false);
        setIsFilter(true);
        setModalVisible(!isModalVisible);
    };
    const onSortPressed = () => {
        setIsSorting(true);
        setIsFilter(false);
        setModalVisible(!isModalVisible);
    };
    const onConfirmPressed = () => {
        setModalVisible(!isModalVisible);
        onGetLeaves()
            // make sure to catch any error
            .catch(console.error);
    }
    // ! Currently Cancel only hides Modal but remembers your changes? I think this is not correct 
    const onCancelPressed = () => {
        setModalVisible(!isModalVisible);
    }
    //#endregion

    //* Render flat list data (leaves)
    const renderLeaves = ({ item }) => {
        let startdate;
        // * IOS specfic date creation
        if (Platform.OS === 'ios') {
            var d = item.startdate.split(/[- :]/);
            // * Get Month Number from month name
            var month = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(d[0]) / 3;
            startdate = new Date(d[2], month, d[1]);
        }
        else {
            startdate = new Date(item.startdate);
        }


        return (
            <Provider>
                <Card
                    style={startdate < new Date() && props.isDashboard === false ? common.cardstyle : styles.cardstyle}
                    onPress={() => clickedItem(item)} >
                    <Card.Content>
                        <ShowHideMenu {...item} />
                    </Card.Content>
                </Card >
            </Provider>
        )
        // }
    };

    const contains = ({ startdate, enddate, acodeDesc, duration, comments, status, rejectionComments, replacementid }, query) => {
        if (startdate.includes(query) || enddate.includes(query) || acodeDesc.includes(query) || duration.includes(query) || comments.includes(query) || status.includes(query) || rejectionComments.includes(query) || replacementid.includes(query)) {
            return true;
        };
        return false;
    };

    // * Search by clicking on the calendar
    const handleSearch = searchText => {
        const formattedQuery = searchText;
        const filteredData = filter(fullData, leave => {
            return contains(leave, formattedQuery);
        });
        if (filteredData.length > 0)
            setData(filteredData);
        else
            setData(fullData)
    };
    //#endregion


    if (useLeaveIsLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )

    return (
        <SafeAreaView style={[styles.mainView, {paddingBottom: Math.max(insets.bottom + 24, 40)}]}>
            {data?.length > 0 ?
                <FlatList
                    data={data}
                    horizontal={Platform.OS === 'web' && width > 1200 ? false : true}
                    renderItem={renderLeaves}
                    onRefresh={() => GetLeaves()}
                    refreshing={loading}
                    keyExtractor={item => `${item.rowguid}`}
                    ListHeaderComponent={
                        (Platform.OS === 'web' && width > 1200) && props.isDashboard === false ? <SafeAreaView>
                            {/*** No need for search. Not deleting just in case.  ***/}
                            {/* <CustomInput
                                        iconName='search'
                                        show='SEARCH'
                                        type='SEARCH'
                                        iconSize={25}
                                        autoCapitalize="none"
                                        autoCorrect={false}
                                        clearButtonMode="always" //ios only
                                        value={query}
                                        setValue={queryText => handleSearch(queryText)}
                                        placeholder={t('common:search')}
                                    /> */}
                            {/* Modal for selection of filters  */}

                            <Modal
                                isVisible={isModalVisible}
                                hasBackdrop={true}
                                backdropColor={colors.background_approved}
                                backdropOpacity={0.9}
                                deviceWidth={deviceWidth}
                                deviceHeight={deviceHeight}
                                onBackdropPress={() => { setModalVisible(false) }}
                                onRequestClose={() => { setModalVisible(false) }}
                            >

                                <View style={{
                                    width: (Platform.OS === 'web' && width > 1200) ? width / 6 : '95%',
                                    alignSelf: 'center',
                                    justifyContent: 'space-between'
                                }}>
                                    {isSorting && <View style={{ height: '20%' }}>
                                        <CustomButton
                                            text={t('common:asc')}
                                            type={dateOrder == 'asc' ? "BORDERLESS_MODAL_SELECTED" : "BORDERLESS_MODAL"}
                                            onPress={toggleModalSortAsc} />
                                        <CustomButton
                                            text={t('common:dsc')}
                                            type={dateOrder == 'desc' ? "BORDERLESS_MODAL_SELECTED" : "BORDERLESS_MODAL"}
                                            onPress={toggleModalSortDsc} />
                                    </View>}
                                    {isFilter && <View style={{
                                        height: '60%'
                                    }}>
                                        <CustomButton
                                            text={t('common:AllLeaves')}
                                            type={approved && rejected && submitted ? "BORDERLESS_MODAL_SELECTED" : "BORDERLESS_MODAL"}
                                            onPress={toggleModalFilterAll} />
                                        <CustomButton
                                            text={t('common:SubmittedLeaves')}
                                            type={!approved && !rejected && submitted ? "BORDERLESS_MODAL_SELECTED" : "BORDERLESS_MODAL"}
                                            onPress={toggleModalFilterSub} />
                                        <CustomButton
                                            text={t('common:ApprovedLeaves')}
                                            type={approved && !rejected && submitted ? "BORDERLESS_MODAL_SELECTED" : "BORDERLESS_MODAL"}
                                            onPress={toggleModalFilterApr} />
                                        <CustomButton
                                            text={t('common:UnsubmittedLeaves')}
                                            type={!approved && !rejected && !submitted ? "BORDERLESS_MODAL_SELECTED" : "BORDERLESS_MODAL"}
                                            onPress={toggleModalFilterUnSub} />
                                        <CustomButton
                                            text={t('common:RejectedLeaves')}
                                            type={!approved && rejected && submitted ? "BORDERLESS_MODAL_SELECTED" : "BORDERLESS_MODAL"}
                                            onPress={toggleModalFilterRej} />
                                        <CustomDropDown
                                            defValue={absDetailYear}
                                            options={mYr}
                                            value={absDetailYear}
                                            setValue={setAbsDetailYear}
                                            type='MODAL'
                                            label={t('common:selectYear')}
                                        />
                                    </View>}
                                    <View style={styles.approverContainer}>
                                        <CustomButton
                                            type="BORDERLESS"
                                            text={t('navigate:cancel')}
                                            onPress={() => onCancelPressed()}
                                        />
                                        <CustomButton
                                            type="BORDERLESS"
                                            text={isFilter == 1 ? t('navigate:filter') : t('navigate:sort')}
                                            onPress={() => onConfirmPressed()}
                                        />
                                    </View>
                                </View>
                            </Modal>

                            <View style={styles.headerContainer}>
                                <CustomLabel
                                    value={data.length + ' records'}
                                    type='TITLE_MUTED' />
                                <View style={styles.rightButtons}>
                                    <CustomButton
                                        iconName='funnel-outline'
                                        show='BORDERLESS_FIXEDWIDTH'
                                        textTop='2'
                                        sz={20}
                                        type="BORDERLESS_FIXEDWIDTH"
                                        onPress={() => onFilterPressed()}
                                    />
                                    <CustomButton
                                        svgName='arrows'
                                        show='BORDERLESS_FIXEDWIDTH'
                                        textTop='2'
                                        sz={20}
                                        type="BORDERLESS_FIXEDWIDTH"
                                        onPress={() => onSortPressed()}
                                    />
                                </View>
                            </View>
                        </SafeAreaView> : <></>
                    }
                    initialNumToRender={4}
                />
                :
                <View style={styles.marginhor}>
                    <CustomLabel
                        value={t('common:noLeaves')}
                        type='MAIN_LABEL_TEAM_SCHEDULE' />
                </View>
            }
        </SafeAreaView>
    )
};


const makeStyles = (colors, props, width) => StyleSheet.create({
    mainView: {
        flex: 1,
        marginVertical: Platform.OS === 'web' ? '0%' : 5,
        justifyContent: 'center'
    },
    textMain: {
        fontSize: Platform.OS === 'web' ? 18 : 14,
        color: colors.text_primary,
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Roboto-Medium',
    },
    cardstyle: {
        margin: 10,
        borderRadius: 5,
        borderWidth: 2,
        borderColor: colors.buttons_submit,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background,
    },
    leaveState: {
        width: 35,
        borderRadius: 5,
        height: 35,
    },
    row: {
        flex: 1,
        flexDirection: "row",
    },
    showDetails: {
        marginVertical: 10,
    },
    spaceBetween: {
        marginLeft: width * 5 / 100,
    },
    flexStart: {
        flex: 1,
        marginBottom: 20,
    },
    spaceStatus: {
        marginTop: width * 5 / 100,
        marginLeft: width * 5 / 100,
        marginRight: width * 5 / 100,
    },
    item: {
        flex: 1,
    },
    showhide: {
        borderRadius: 35,
        backgroundColor: colors.background_card,
    },
    line: {
        borderBottomColor: colors.green,
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: (Platform.OS === 'web') ? 10 : 20,
        marginBottom: (Platform.OS === 'web') ? 10 : 20,
    },
    approverContainer: {
        // flex: 1,
        // marginTop: 30,
    },
    headerContainer: {
        flexDirection: 'row',           // Arrange children in a row
        justifyContent: 'space-between', // Space between left and right sides
        alignItems: 'center',           // Vertically centre items
        paddingHorizontal: 0,          // Horizontal padding
        paddingVertical: 10,            // Vertical padding
    },
    rightButtons: {
        flexDirection: 'row',           // Arrange buttons horizontally
        gap: 10,                       // Space between buttons (React Native 0.71+)
    },
    leaveLine: {
        flex: 3,
    },
    marginhor: {
        marginHorizontal: 10,
    },
});

export default MyLeavesScreen;